module.exports = __webpack_public_path__ + "static/media/modal.2c59372a.png";